export default class ServiceModel {
  public static get crating() {
    return {
      id: 0,
      additional_service_id: 17,
      params: null,
      settings: {price_per_cf: 0.15},
      price: 151,
      name: 'Crating',
      lead_location_id: 0,
      details: {
        id: 17,
        name: 'Crating',
        settings: {price_per_cf: 0.15},
        type: 1,
        type_text: 'pickup',
        class_name: 'Crating',
        selectable: 0,
      },
    }
  }

  public static get fullPack() {
    return {
      id: 0,
      additional_service_id: 6,
      params: null,
      settings: {
        price_per_cf: 1.5,
      },
      price: 108,
      name: 'Full Pack',
      lead_location_id: 0,
      details: {
        id: 6,
        name: 'Full Pack',
        settings: {
          price_per_cf: 1.5,
        },
        type: 1,
        type_text: 'pickup',
        class_name: 'Packing',
        selectable: 1,
      },
    }
  }

  public static get partialPack() {
    return {
      id: 0,
      additional_service_id: 7,
      params: null,
      settings: null,
      price: 18,
      name: 'Partial Pack',
      lead_location_id: 0,
      details: {
        id: 7,
        name: 'Partial Pack',
        settings: null,
        type: 1,
        type_text: 'pickup',
        class_name: 'PartialPacking',
        selectable: 0,
      },
    }
  }
}
